export enum AppointmentStatusEnum {
    Agendado = 1,
    ConsultaFinalizada = 2,
    NaoCompareceu = 3,
    Evadiu = 4,
    AgendamentoCancelado = 5,
    MedicoNaoCompareceu = 6,
    MedicoEvadiu = 7,
    CanceladoPeloMedico = 8,
}